<template>
    <v-img
        v-if="$country.getCountryObject() && $country.getCountryObject().image_path"
        :src="$country.getCountryObject().image_path"
        :alt="$language.translate($country.getCountryObject().name)"
        @click="$root.showLanguageModal = true"
        contain
    />
</template>

<style scoped>
    .v-image {
        cursor: pointer;
    }
</style>

<script>
    export default {
        name: 'CountryImage',
    };
</script>